module.exports = __webpack_public_path__ + "media/images/icon-add-eac694b3da5ef9a5348609fbcfbe0736.png";